import { useState } from "react";
import { UserRound } from "lucide-react";

const PLACEHOLDER_SRC = "/prophets/placeholder-portrait.png";

interface ProphetImagePlaceholderProps {
  className?: string;
}

export function ProphetImagePlaceholder({ className }: ProphetImagePlaceholderProps) {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div className={`flex items-center justify-center bg-surface-2 ${className ?? ""}`}>
        <UserRound className="h-1/3 w-1/3 text-muted" />
      </div>
    );
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={PLACEHOLDER_SRC}
      alt=""
      className={`object-cover bg-surface-2 ${className ?? ""}`}
      onError={() => setErrored(true)}
    />
  );
}
